import React, { useMemo } from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

interface Props {
  services: string[]
}

export default function ServicePicklist({
  name = 'service',
  label = 'Service',
  compact = false,
  services = [],
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  const options = useMemo(() => {
    return services.map((service) => ({
      label: service,
      value: service,
    }))
  }, [services])

  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
